// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_s7y","cls2":"AuthorHeader-cls2_nvO AuthorHeader-cls1_s7y"};